module.exports = __webpack_public_path__ + "static/wordpress-logo-223f2bca8e9758cb7ee8e14d9eba691e.png";